<template>
    <div class="btnUser" :style="{ width: size + 'px', height: size + 'px' }" :class="{
        'player-avatar-reserved': isReserved, selectable:
            selectable
    }">

        <div v-if="isTui" class="facilitator-circle"></div>

        <div v-else class="btnUserImgContainer" :class="{ 'player-avatar-reserved-inner': isReserved }">
            <svg class="player-avatar-background" :class="{
                'player-avatar-background-selected': isSelected,
                'player-avatar-background-turn-prompt': isTurnPrompt
            }" width="100%" height="100%" viewBox="0 0 132 132" version="1.1" xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink">
                <defs>
                    <polygon id="path-1" points="0 0 132 0 132 132 0 132" />
                    <polygon id="path-3" points="0 0 71.08252 0 71.08252 62.6156271 0 62.6156271" />
                </defs>
                <g id="round-one" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g id="round-one-low" transform="translate(-47.000000, -113.000000)">
                        <g id="player-avatar" transform="translate(47.000000, 113.000000)">
                            <g id="avatar-frame">
                                <mask id="mask-2" fill="white">
                                    <use xlink:href="#path-1" />
                                </mask>
                                <g id="Clip-784" />
                                <path
                                    d="M65.9997631,132 C102.450585,132 132,102.451367 132,66.0006768 C132,29.5493094 102.450585,0 65.9997631,0 C29.5489416,0 -0.000473765249,29.5493094 -0.000473765249,66.0006768 C-0.000473765249,102.451367 29.5489416,132 65.9997631,132"
                                    id="Fill-783" :fill="fill" mask="url(#mask-2)" />
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
            <img class="player-avatar btn-snd" :style="{ height: isTui ? size - 8 + 'px' : sizeInner + 'px' }"
                :src="imageSrc" />
        </div>
        <template v-if="username">
            <p class="username" v-html="T(username)"></p>
            <p class="realname" v-html="T(realname)"></p>
        </template>
        <template v-if="gamedisplayname">
            <p class="gamedisplayname" :style="{ color: fill }" v-html="T(gamedisplayname)"></p>
        </template>

        <div class="ribbon"
            :style="{ width: FixRibbonSize(79) + 'px', 'line-height': FixRibbonSize(14) + 'px', 'font-size': FixRibbonSize(14) + 'px', height: FixRibbonSize(24) + 'px', bottom: FixRibbonSize(-14) + 'px' }"
            v-if="showRibbon" v-html="realNameFromData"></div>

    </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { users } from '../../../shared_fca/room_user';
import { T } from '@/App.vue';

export default Vue.extend({
    props: {
        isSelected: Boolean,
        isReserved: Boolean,
        isTurnPrompt: Boolean,
        id: String,
        username: String,
        realname: String,
        size: Number,
        sizeInner: Number,
        selectable: Boolean,
        gamedisplayname: String,
        isTui: Boolean,

        //Shows name with ribbon
        showRibbon: Boolean,
    },
    computed: {
        fill: {
            cache: false,
            get(): string {
                return users[this.id].fill;
            }
        },
        realNameFromData: {
            cache: false,
            get(): string {
                return T(users[this.id].realname);
            }
        },
        imageSrc: {
            cache: false,
            get(): string {
                return 'avatars/avatar' + this.realNameFromData + '.png';
            }
        },
    },
    methods: {
        T(key: string): string {
            return T(key);
        },
        FixRibbonSize(input: number): number {
            return input * this.size / 79;
        }
    },
    name: 'AvatarCircle',
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.ribbon {
    background-image: url("../assets-fca/UI/name_ribbon.svg");
    background-size: cover;
    font-family: Rubik;
    font-weight: 800;
    text-align: center;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: #fff;
    position: absolute;
    bottom: 0px;
    left: 50%;
    transform: translate(-50%, 0);        
}

.facilitator-circle {
    width: 100%;
    height: 100%;
    background-image: url("../assets-fca/Guide/facilitator-circle.svg");
    background-size: cover;
}

.player-avatar-reserved {
    pointer-events: none;
}

.player-avatar-reserved-inner {
    filter: brightness(0.3);
}

.player-avatar-background-selected {
    background-color: #ebd46b; //#e5aa63;
    border: 8px solid #ebd46b; // #e5aa63;
    border-radius: 1000px;
}

.player-avatar-background-turn-prompt {
    background-color: #E9E9E9; //#e5aa63;
    border: 4px solid #E9E9E9;
    border-radius: 1000px;
}

.btnUserImgContainer {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
}

.selectable {
    cursor: pointer;
}

.btnUser {
    color: #fff;
    font-family: Rubik;
    font-size: 18px;
    font-weight: bold;
    letter-spacing: 0.01px;
    line-height: 22px;
    text-align: center;
    position: relative;
}

.player-avatar {
    position: absolute;
}

.username {
    height: 29px;
    color: #fff;
    font-family: Rubik;
    font-size: 18px;
    letter-spacing: 0.01px;
    line-height: 22px;
    text-align: center;
    margin-top: 12px;
    margin-bottom: 0px;
}

.realname {
    color: #fff;
    font-family: Rubik;
    font-size: 18px;
    letter-spacing: 0.01px;
    line-height: 22px;
    text-align: center;
    font-weight: normal;
}

.gamedisplayname {
    color: #D68D2D;
    font-family: Rubik;
    font-size: 23.89px;
    font-weight: 800;
    letter-spacing: -0.45px;
    line-height: 28px;
}
</style>